export default __webpack_public_path__ + "static/media/Twitter_Rounded.7ffaf6a5.png";